import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/atc/ATC CREAM pineapple.png";
import BiscuitImg from "../../../assets/products/atc/ATC-Pineapple.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 125,
  },
  {
    grams: 150,
  },
];

export default function PineappleATCProduct() {
  return (
    <>
      <Helmet>
        <title>
          ATC Pineapple Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz ATC Pineapple Cream Biscuits — tropical pineapple-flavored cream biscuits in ATC format. View pack sizes and global specifications."
        />
        <meta
          name="keywords"
          content="ATC Pineapple Cream Biscuit, BearBitz ATC Pineapple"
        />
        <link rel="canonical" href="https://www.bearbitz.in/atc/pineapple" />
        <meta
          property="og:title"
          content="ATC Pineapple Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Pineapple cream biscuit in ATC format with export-ready packaging and premium flavor."
        />
      </Helmet>

      <ProductTemplate
        productTitle="PINEAPPLE"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in The rich taste of ATC Cream Biscuits, where every crunchy bite meets a smooth and creamy filling."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#C7FA86"
        sectionBgColor="#E6FFC6"
        productBgcolor="#C5FC7C"
        tableheadBgcolor="#629C14"
        tableBgcolor="#F0FFDD"
        footerBgcolor="#629C14"
      />
    </>
  );
}
